<img
  src="{{ input.url | parse: context | async }}"
  alt="TrackBack"
  [matTooltip]="tooltipText"
  [matTooltipPosition]="tooltipPosition"
  crossorigin="use-credentials"
/>
